import { ClothesDetectionResponse } from "../types/free-trial/auto-tagging-service/types";
import instance from "./axiosInstance";

export const autoTaggingService = async (accessToken: string, image: string, subUserId?: string | number): Promise<ClothesDetectionResponse> => {
  try {
    const response = await instance.post<ClothesDetectionResponse>(
      "/api/v1/services/autoTagging",
      { image, sub_user_id: subUserId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Error submitting auto tagging:", error);
    throw error;
  }
};
